export default "__VITE_PUBLIC_ASSET__d60e7c86__"